import React from 'react';
import { Globe2 } from 'lucide-react';

/**
 * Reassures Latin American buyers that the USD price is charged
 * in their own currency at checkout.
 */
export const LocalCurrencyNote = ({
  className = ''
}: {
  className?: string;
}) => <div className={`mx-auto flex w-full max-w-[320px] items-start gap-2.5 rounded-2xl border border-sky-400/25 bg-sky-400/[0.06] px-3.5 py-2.5 ${className}`} data-id="element-365" data-mp="103h5i2e2djpi">
    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-sky-400/15 text-sky-400" data-id="element-366" data-mp="q7e26t7h7f0z">
      <Globe2 size={13} aria-hidden="true" data-id="element-367" data-mp="lfckusvgay43" />
    </span>
    <div className="min-w-0 text-left" data-id="element-368" data-mp="hekd6428919x">
      <p className="text-[10px] font-bold uppercase tracking-widest text-sky-400" data-id="element-369" data-mp="hflw0uphis27">
        Pagas en tu moneda local
      </p>
      <p className="mt-0.5 text-xs leading-snug text-slate-300" data-id="element-370" data-mp="chancnaxenlk">
        El precio se convierte automáticamente al finalizar la compra.
      </p>
    </div>
  </div>;